import * as React from 'react';
import * as styles from './ContentCreator.css';
import { LocalizationService } from '../../services/LocalizationService';
import { IAPanel } from '../panels/Panel';
import { IUser } from '../../interfaces/IUser';
import { IAPivot } from '../pivot/Pivot';
import { AddNewButton } from './addNewButton/AddNewButton';
import { Provider } from 'mobx-react';
import { MessagesStore } from '../messages/stores';
import ContentCreatorService from '../../services/ContentCreatorService';
import { IContentCreatorItem } from '../../interfaces/IContentCreatorItem';
import DateTimeService from '../../services/DateTimeService';
import { TenantSettingsService } from 'intraactive-sdk-helper';
import { ITenantSettings } from '../../interfaces/ITenantSettings';
import { Environment } from '../../services/Environment';
import { IAIcon } from '../icon/Icon';
import { IInstance } from '../../interfaces/IInstance';
import { IContentCreator } from '../../interfaces/IContentCreator';
import { IAButton } from '../button/Button';
import { IAPopup } from '../popup/Popup';
import { Helper } from '../../Helper';
import { IMyContent } from '../../interfaces/IMyContent';
import { IMyContentItem } from '../../interfaces/IMyContentItem';
import { ContentCreatorItem } from './contentCreatorItem/ContentCreatorItem';
import EventService from '../../services/EventService';
import MessageService from '../../services/MessageService';
import { IMessageResult } from '../../interfaces/IMessageResult';
import { OldViewPanel } from '../messages/panels/OldViewPanel';
import InstanceService from '../../services/InstanceService';
import { OuterFilterPanel } from './panels/OuterFilterPanel';
import { FilterService } from '../messages/Filter.service';
import * as constants from '../../global/Constants';
import "../../styles/BasicIA.css";
import ContentOrganizerService from '../../services/ContentOrganizerService';
import { IComponentInstances } from '../../interfaces/IComponentInstances';
import UserService from '../../services/UserService';
import { IUserRole } from '../../interfaces/IUserRole';
import SocialService from '../../services/SocialService';
import { IAPushMessageItem } from './pushMessageItem/PushMessageItem';
import { EditPanel } from '../messages/panels/EditPanel';
import { ViewPanel } from '../messages/panels/ViewPanel';
import { IHttpStatus } from '../../interfaces/IHttpStatus';
import { IMessage } from '../../interfaces/IMessage';
import { ContentOrganizerPanel } from './panels/contentOrganizerPanel/ContentOrganizerPanel';
import { sdkContainerInstance } from '../global';
import { IASkeleton } from '../skeleton/Skeleton';
import MessageTemplateService from '../../services/MessageTemplateService';
import { IFontSlots } from '../../interfaces/IFontSlots';
import EventTemplateService from '../../services/EventTemplateService';
import { IApprover } from '../../interfaces/IApprover';

export interface IProps {
  show: boolean;
  showFilter: boolean;
  tenant: string;
  instance: IInstance;
  token: string;
  environment: "Development" | "Test" | "Production";
  isMobile: boolean;
  marginTop: number;
  user: IUser;
  highlightColor: string;
  fontSlots?: IFontSlots;
  onClose: () => void;
  onCloseFilter: () => void;
  componentInstances: IComponentInstances;
}

export interface IState {
  selectedTab: "AddNew" | "MyContent" | "WaitingForApproval" | "PushMessages";
  show: boolean;
  showFilter: boolean;
  showCancelPopup: boolean;
  showDeletePopup: boolean;
  buttons: IContentCreatorItem[];
  myContentItems: IMyContentItem[];
  myContentInstances: IMyContentItem[];
  myContentTotalItems: number;
  loadingButtons: boolean;
  loadingMoreContent: boolean;
  loadingMoreContentPush: boolean;
  contentItemToDelete: IMyContentItem;
  contentItemToEdit: IMyContentItem;
  contentItemToOpen: IMyContentItem;
  contentItemToReview: IMyContentItem;
  loading: boolean;
  clearFiltersKey: string;
  filterChange?: boolean;
  waitingForApprovalItems: IMyContentItem[];
  waitingForApprovalTotalItems: number;
  botMessagesItems: IMyContentItem[];
  botMessagesTotalItems: number;
  showConvertToComposerPopup?: IMessage;
  contentOrganizerInstanceToAddTo?: IInstance;
}

export class IAContentCreator extends React.Component<IProps, IState> {

  private messagesStore: MessagesStore;
  private readonly dateTimeService: DateTimeService = new DateTimeService();
  private cancelPopupId;
  private deletePopupId;
  private convertPopupId;
  private focusRef: React.RefObject<HTMLDivElement>;
  private filterRef: React.RefObject<HTMLDivElement>;
  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedTab: "AddNew",
      show: props.show,
      showFilter: props.showFilter,
      showCancelPopup: false,
      showDeletePopup: false,
      buttons: [],
      myContentItems: [],
      myContentInstances: [],
      myContentTotalItems: 0,
      loadingButtons: false,
      loadingMoreContent: false,
      loadingMoreContentPush: false,
      contentItemToDelete: undefined,
      contentItemToEdit: undefined,
      contentItemToOpen: undefined,
      contentItemToReview: undefined,
      loading: false,
      filterChange: false,
      clearFiltersKey: Helper.getRandomStringKey(),
      waitingForApprovalItems: [],
      waitingForApprovalTotalItems: 0,
      botMessagesItems: [],
      botMessagesTotalItems: 0
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());

    this.deletePopupId = Helper.getRandomStringKey();
    this.cancelPopupId = Helper.getRandomStringKey();
    this.convertPopupId = Helper.getRandomStringKey();

    this.filterRef = React.createRef();
    this.focusRef = React.createRef();

    // MessagesStore
    this.messagesStore = new MessagesStore();
    this.messagesStore.component = "ContentCreator";
    this.messagesStore.token = this.props.token;
    this.messagesStore.tenant = this.props.tenant;
    this.messagesStore.environment = this.props.environment;
    this.messagesStore.highlightColor = this.props.highlightColor;
    this.messagesStore.isMobile = this.props.isMobile;
    this.messagesStore.user = this.props.user;
    this.messagesStore.fontSlots = this.props.fontSlots;
    // this.messagesStore.likesEnabled = true;
    // this.messagesStore.commentsEnabled = true;
    this.messagesStore.showOuterPanel = this.state.showFilter;
    this.messagesStore.isMobile = window.innerWidth <= 667;

    // Targeting
    this.messagesStore.getTargetingApplication().then(() => {
      this.messagesStore.getTargetingProperties();
    });
  }

  public componentWillUnmount(): void {
    document.removeEventListener("keydown", (event) => this.keyListener(event), false);
  }

  public componentDidMount(): void {
    document.addEventListener("keydown", (event) => this.keyListener(event), false);
    this.getTenantInfo();

    if (!this.messagesStore.user && this.messagesStore.instance) {
      UserService.getUserRoleForMessages(Environment.getEnvironmentForMainAPI(this.messagesStore.environment), this.messagesStore.tenant, this.messagesStore.instance?.id, this.messagesStore.component === "Messages" ? "IntraActive-Messages" : "IntraActive-Events").then((result: { httpStatus: IHttpStatus, value?: IUserRole }) => {
        if (result.httpStatus.statusCode === 200) {
          this.messagesStore.setUserRole(result.value);
        }
      });
    }
  }

  private async getTenantInfo() {
    if (this.messagesStore.environment && this.messagesStore.tenant && this.messagesStore.token) {
      const tenantSettingsService = new TenantSettingsService<ITenantSettings>(Environment.getEnvironmentForSettingsAPI(this.messagesStore.environment), sdkContainerInstance);
      const tenantSettings = localStorage.getItem("IA_tenantSettings");
      if (tenantSettings && new DateTimeService().getDatePlusTwoMinuts(new Date(JSON.parse(tenantSettings).date)) > new Date()) {
        console.log("Using cached tenant settings");
        this.messagesStore.tenantSettings = JSON.parse(tenantSettings).value;
        await this.messagesStore.getNewBotInstallationStatus();
      } else {
        console.log("Fetching tenant settings again");
        tenantSettingsService.getSettings(this.messagesStore.tenant, undefined, this.messagesStore.token).then(async setting => {
          this.messagesStore.tenantSettings = setting;
          Helper.setLocalStorage("IA_tenantSettings", JSON.stringify({
            date: new Date(),
            value: setting
          }));
          await this.messagesStore.getNewBotInstallationStatus();
        });
      }
    }
  }

  private keyListener(event: KeyboardEvent): void {
    if (event.keyCode === constants.ESC_KEY_CODE) {
      this.escFunction();
    } else if (event.keyCode === constants.LEFTARROW_KEY_CODE) {
      this.focusOnContentCreator();
    }
  }

  private escFunction(): void {
    if (this.messagesStore && this.messagesStore.messageToOpen === undefined && this.messagesStore.messageToEdit === undefined) {
      this.state.show && this.state.showFilter ? this.setState({ showFilter: false }) : this.setState({ show: false, showFilter: false });
    }
  }

  private focusOnContentCreator(): void {
    if (this.state.showFilter) {
      this.filterRef.current.focus();
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (!this.messagesStore.user && props.user) {
      this.messagesStore.user = props.user;
    }
    if (props.show) {
      this.focusRef.current.focus();
    }

    this.setState({ show: props.show, showFilter: props.showFilter });
    if (props.instance) {
      this.getButtons(props.environment, props.token, props.tenant, props.instance.instanceName);
    }
  }

  private getButtons(environment: "Development" | "Test" | "Production", token: string, tenant: string, instanceName: string): void {
    this.setState({ loadingButtons: true });
    ContentCreatorService.get(environment, token, tenant, instanceName).then((contentCreator: IContentCreator) => {
      this.setState({ buttons: contentCreator.config });
      this.setState({ loadingButtons: false });
      InstanceService.getInstances(this.props.environment, this.props.token, this.props.tenant, "IntraActive-Messages", false).then((instances: IInstance[]) => {
        this.state.buttons.forEach((button: IContentCreatorItem) => {
          instances.forEach((instance: IInstance) => {
            if (!instance.instanceName) {
              instance.instanceName = "Default";
            }
            if (button.component === "Messages" && button.instance.instanceName === instance.instanceName) {
              button.instance = instance;
            }
          });
        });
        this.messagesStore.readableMessageInstances = instances;
      });
      InstanceService.getInstances(this.props.environment, this.props.token, this.props.tenant, "IntraActive-Events", false).then((instances: IInstance[]) => {
        this.state.buttons.forEach((button: IContentCreatorItem) => {
          instances.forEach((instance: IInstance) => {
            if (!instance.instanceName) {
              instance.instanceName = "Default";
            }
            if (button.component === "Event" && button.instance.instanceName === instance.instanceName) {
              button.instance = instance;
            }
          });
        });
        this.messagesStore.readableEventsInstances = instances;
      });
      InstanceService.getInstances(this.props.environment, this.props.token, this.props.tenant, "IntraActive-ContentOrganizer", false).then((instances: IInstance[]) => {
        this.state.buttons.forEach((button: IContentCreatorItem) => {
          instances.forEach((instance: IInstance) => {
            if (button.component === "ContentOrganizer" && button.instance.instanceName === instance.instanceName) {
              button.instance = instance;
            }
          });
        });
        this.messagesStore.readableContentOrganizerInstances = instances;
      });
    })
  }

  private loadMyContentInstances(): void {
    ContentCreatorService.getMyContentInstances(
      this.props.environment,
      this.props.token,
      this.props.tenant
    )
      .then((myContentInstances: IMyContent) => {
        let tempItems, tempInstances;
        tempItems = myContentInstances.items;
        tempInstances = tempItems.map(x => ({ "key": x.site + " - " + x.instanceName, "instanceName": x.instanceName, "site": x.site }));
        tempInstances = Array.from(new Set<object>(tempInstances.map(item => item.key)));
        this.setState({
          myContentInstances: tempInstances
        });
        this.messagesStore.availableInstances = tempInstances;
      })
  }

  private getMyContent(resetPageCount: boolean = false): void {
    if (this.state.loadingMoreContent) {
      return;
    }
    this.setState({ loadingMoreContent: true }, () => this.forceUpdate());
    ContentCreatorService.getMyContent(
      this.props.environment,
      this.props.token,
      this.props.tenant,
      this.state.myContentItems != undefined && (this.state.myContentItems.length != 0 && !this.messagesStore.filterData.hasChanged) ? this.state.myContentItems.length : 0,
      FilterService.get(this.messagesStore.isAdminPage, this.messagesStore.filterData, this.messagesStore.shouldFilterByCategory, this.messagesStore.selectedInstances, this.messagesStore.numMessages, this.messagesStore.pagingInfo, "ContentCreator", this.messagesStore.startDate, this.messagesStore.endDate, this.messagesStore.showPeriod),
    )
      .then((myContent: IMyContent) => {
        let tempItems, tempInstances;
        let hasFilterDataChanged = this.messagesStore.filterData.hasChanged;

        if ((this.state.myContentItems != undefined && this.state.myContentItems.length > 0 && !hasFilterDataChanged) && !resetPageCount) {
          tempItems = this.state.myContentItems.slice();
          tempItems = tempItems.concat(myContent.items);
        } else {
          tempItems = myContent.items;
          this.messagesStore.updateFilter(this.messagesStore.filterData);
        }
        tempInstances = tempItems.map(x => ({ "key": x.site + " - " + x.instanceName, "instanceName": x.instanceName, "site": x.site }));
        tempInstances = Array.from(new Set<object>(tempInstances.map(item => item.key)));
        this.setState({
          myContentItems: tempItems,
          myContentTotalItems: myContent.totalItems,
          loadingMoreContent: false
        })
      }).then(() => {
        const isFilterInstancListLoaded = this.state.myContentInstances;
        if (isFilterInstancListLoaded.length === 0) {
          this.loadMyContentInstances();
        }
        this.messagesStore.filterData.hasChanged = false;
      });
  }

  private getWaitingForApproval(resetPageCount: boolean = false): void {
    this.setState({ loadingMoreContent: true }, () => this.forceUpdate());
    ContentCreatorService.getWaitingForApproval(
      this.props.environment,
      this.props.token,
      this.props.tenant,
      this.state.waitingForApprovalItems != undefined ? this.state.waitingForApprovalItems.length : 0
    )
      .then((waitingForApproval: IMyContent) => {
        let tempItems: IMyContentItem[];
        if (this.state.waitingForApprovalItems != undefined && this.state.waitingForApprovalItems.length > 0 && !resetPageCount) {
          tempItems = this.state.waitingForApprovalItems.slice();
          tempItems = tempItems.concat(waitingForApproval.items);
        } else {
          tempItems = waitingForApproval.items;
        }
        this.setState({
          waitingForApprovalItems: tempItems,
          waitingForApprovalTotalItems: waitingForApproval.totalItems,
          loadingMoreContent: false
        })
      });
  }


  private getBotMessages(resetPageCount: boolean = false): void {
    this.setState({ loadingMoreContentPush: true }, () => this.forceUpdate());
    ContentCreatorService.getBotMessages(
      this.props.environment,
      this.props.token,
      this.props.tenant,
      this.state.botMessagesItems != undefined ? this.state.botMessagesItems.length : 0
    )
      .then((botMessagesItems: IMyContent) => {
        let tempItems: IMyContentItem[];
        if (this.state.botMessagesItems && this.state.botMessagesItems.length > 0 && !resetPageCount) {
          tempItems = this.state.botMessagesItems.slice();
          tempItems = tempItems.concat(botMessagesItems.items);
        } else {
          tempItems = botMessagesItems.items;
        }
        this.setState({
          botMessagesItems: tempItems,
          botMessagesTotalItems: botMessagesItems.totalItems,
          loadingMoreContentPush: false
        })
      });
  }

  private showItem(contentItemToOpen: IMyContentItem): void {
    this.setState({
      contentItemToOpen,
      loading: true
    });
    this.messagesStore.user = this.props.user;
    switch (contentItemToOpen.site.toLocaleLowerCase()) {
      case "intraactive-messages":
        this.messagesStore.instance = this.messagesStore.readableMessageInstances?.filter(i => i.instanceName === contentItemToOpen.instanceName)[0];
        this.messagesStore.component = "Messages";
        MessageService.getMessage(this.props.environment, this.props.token, this.props.tenant, contentItemToOpen.instanceName, contentItemToOpen.listItemId).then((messageResult: IMessageResult) => {
          messageResult.messages[0].likes = undefined;
          messageResult.messages[0].commentCount = undefined;
          this.messagesStore.messageToOpen = messageResult.messages[0];
          this.messagesStore.isTargetingAvailable = true; // TODO
          this.messagesStore.creatingNewMessage = false;
          this.messagesStore.categoryNodes = undefined;
          this.setState({ loading: false }, this.forceUpdate);

        });
        break;
      case "intraactive-events":
        this.messagesStore.instance = this.messagesStore.readableEventsInstances?.filter(i => i.instanceName === contentItemToOpen.instanceName)[0];
        this.messagesStore.component = "Event";
        EventService.getEvent(this.props.environment, this.props.token, this.props.tenant, contentItemToOpen.instanceName, contentItemToOpen.listItemId).then((messageResult: IMessageResult) => {
          messageResult.messages[0].likes = undefined;
          messageResult.messages[0].commentCount = undefined;
          this.messagesStore.messageToOpen = messageResult.messages[0];
          this.messagesStore.isTargetingAvailable = true; // TODO
          this.messagesStore.creatingNewMessage = false;
          this.messagesStore.categoryNodes = undefined;
          this.setState({ loading: false }, this.forceUpdate);
        });
        break;
      case "intraactive-contentorganizer":
        this.messagesStore.component = "ContentOrganizer";
        window.open(contentItemToOpen.url, "_blank");
        this.setState({ loading: false });
        break;
      default:
        throw new Error("Not implemented");
    }
  }

  private editItem(contentItemToEdit: IMyContentItem): void {
    this.setState({
      contentItemToEdit,
      loading: true
    });
    this.messagesStore.component = contentItemToEdit.site === "IntraActive-Messages" ? "Messages" : "Event";
    this.messagesStore.user = this.props.user;
    if (this.messagesStore.component === "Messages") {
      this.messagesStore.instance = this.messagesStore.readableMessageInstances?.filter(i => i.instanceName === contentItemToEdit.instanceName)[0];
      MessageService.getMessage(this.props.environment, this.props.token, this.props.tenant, contentItemToEdit.instanceName, contentItemToEdit.listItemId).then((messageResult: IMessageResult) => {
        if (messageResult?.messages[0].iaConfiguration?.composerComponents) {
          this.messagesStore.messageToEdit = messageResult.messages[0];
        } else {
          this.setState({
            showConvertToComposerPopup: messageResult?.messages[0]
          });
        }
        // Targeting
        this.messagesStore.getTargetingApplication().then(() => {
          this.messagesStore.getTargetingProperties();
          this.forceUpdate();
        });
        this.messagesStore.isTargetingAvailable = true; // TODO
        this.messagesStore.creatingNewMessage = false;
        this.messagesStore.categoryNodes = undefined;
        this.messagesStore.getInstance().then(() => {
          if (this.messagesStore.instance?.approvalEnabled && this.messagesStore.instance.approvers?.length > 0) {
            this.messagesStore.messageToEdit.approvers = this.messagesStore.instance.approvers as IApprover[];
          }
        this.messagesStore.messageToEditOriginal = Object.assign({}, this.messagesStore.messageToEdit);
          this.setState({
            loading: false
          });
        });
        this.forceUpdate();
      });
    } else {
      this.messagesStore.instance = this.messagesStore.readableEventsInstances?.filter(i => i.instanceName === contentItemToEdit.instanceName)[0];
      EventService.getEvent(this.props.environment, this.props.token, this.props.tenant, contentItemToEdit.instanceName, contentItemToEdit.listItemId).then((messageResult: IMessageResult) => {
        if (messageResult?.messages[0].iaConfiguration?.composerComponents) {
          messageResult.messages[0].contacts = [messageResult.messages[0].author];
          this.messagesStore.messageToEdit = messageResult.messages[0];
        } else {
          this.setState({
            showConvertToComposerPopup: messageResult?.messages[0]
          });
        }
        // Targeting
        this.messagesStore.getTargetingApplication().then(() => {
          this.messagesStore.getTargetingProperties();
          this.forceUpdate();
        });
        this.messagesStore.creatingNewMessage = false;
        this.messagesStore.categoryNodes = undefined;
        this.messagesStore.messageToEditOriginal = Object.assign({}, this.messagesStore.messageToEdit);
        this.messagesStore.getInstance().then(() => {
          this.setState({
            loading: false
          });
          this.forceUpdate();
        });
      });
    }
  }

  private showFilter(): void {
    this.messagesStore.showOuterPanel = true;
    this.setState({ showFilter: true });
  }

  private clearFilters(): void {
    this.messagesStore.updateFilter({
      isFiltered: false,
      showOnlyAuthorMessages: "All",
      showPeriodMessage: "All time",
      selectedPeolple: [],
      selectedCategories: this.messagesStore.selectedCategories ? this.messagesStore.selectedCategories : [],
      startDate: undefined,
      endDate: undefined,
      selectedTypesOfContent: [],
      selectedInstances: [],
      selectedItemStatus: [],
      hasChanged: true,
    });
    this.setState({ clearFiltersKey: Helper.getRandomStringKey() });
    this.getMyContent();
  }

  public render(): JSX.Element {
    // Add Content
    let elements = [];
    if (this.state.loadingButtons) {
      for (let i = 0; i < 4; i++) {
        elements.push(
          <IASkeleton
            key={i}
            skeleton={{
              height: 50,
              width: "auto",
              marginBottom: 20,
              borderRadius: 5
            }}
          />
        );
      }
    } else if (!this.state.loadingButtons && this.state.buttons.length > 0) {
      this.state.buttons.forEach((button: IContentCreatorItem, index) => {
        elements.push(
          <AddNewButton
            key={`AddNewButton_${index}`}
            color={this.props.highlightColor}
            icon={button.icon}
            fontSlots={this.props.fontSlots}
            title={button.title}
            description={button.description}
            onClick={async () => {
              this.setState({ loading: true });
              if (button.component === "ContentOrganizer") {
                this.setState({ contentOrganizerInstanceToAddTo: button.instance, loading: false });
              } else {
                this.messagesStore.component = button.component;
                this.messagesStore.instance = button.instance;
                this.messagesStore.isTargetingAvailable = true; // TODO
                this.messagesStore.creatingNewMessage = true;
                this.messagesStore.categoryNodes = undefined;
                const renamedComponent = button.component === "Messages" ? "Messages" : "Events";
                if (renamedComponent === "Messages" || renamedComponent === "Events") {
                  await SocialService.areCommentsAndLikesEnabled(this.props.environment, this.props.tenant, this.props.token, button.instance.instanceName, renamedComponent).then((response: any) => {
                    this.messagesStore.likesEnabled = response.likesEnabled;
                    this.messagesStore.commentsEnabled = response.commentsEnabled;
                    Helper.setLocalStorage(`messagesWebpartLikesEnabledForInstance-${button.instance.instanceName}-${renamedComponent}`, JSON.stringify(response.likesEnabled));
                    Helper.setLocalStorage(`messagesWebpartCommentsEnabledForInstance-${button.instance.instanceName}-${renamedComponent}`, JSON.stringify(response.commentsEnabled));
                  });
                }
                this.messagesStore.messageToEditOriginal = Object.assign({}, this.messagesStore.messageToEdit);
                if (button.component === "Messages" || button.component === "Event") {
                  await this.messagesStore.getTargetingApplication();
                  await this.messagesStore.getTargetingProperties();
                  await this.messagesStore.getInstance();
                  this.forceUpdate();
                }
                if (button.templateId) {
                  if (button.component === "Messages") {
                    MessageTemplateService.getTemplate(this.props.environment, this.props.tenant, button.instance.instanceName, button.templateId).then(async (template) => {
                      this.messagesStore.messageToEdit = await this.messagesStore.setTemplateProperties(JSON.parse(template.jsonTemplate), this.messagesStore.getMessageEndDate());
                      if (this.messagesStore.instance?.approvalEnabled && this.messagesStore.instance.approvers?.length > 0) {
                        this.messagesStore.messageToEdit.approvers = this.messagesStore.instance.approvers as IApprover[];
                      }
                      this.forceUpdate();
                    }).finally(() => {
                      this.setState({ loading: false });
                    });
                  }
                  if (button.component === "Event") {
                    EventTemplateService.getTemplate(this.props.environment, this.props.tenant, button.instance.instanceName, button.templateId).then(async (template) => {
                      this.messagesStore.messageToEdit = await this.messagesStore.setTemplateProperties(JSON.parse(template.jsonTemplate), this.messagesStore.getMessageEndDate());
                      if (this.messagesStore.instance?.approvalEnabled && this.messagesStore.instance.approvers?.length > 0) {
                        this.messagesStore.messageToEdit.approvers = this.messagesStore.instance.approvers as IApprover[];
                      }
                      this.forceUpdate();
                    }).finally(() => {
                      this.setState({ loading: false });
                    });
                  }
                } else {
                  // backwards compatibility with the "old" content creator
                  const approvers = (this.messagesStore.instance?.approvalEnabled && this.messagesStore.instance.approvers?.length > 0) 
                    ? this.messagesStore.instance.approvers as IApprover[]
                    : undefined;             
                  this.messagesStore.messageToEdit = {
                    title: undefined,
                    content: undefined,
                    push: this.messagesStore.instance?.pushEnabled && this.messagesStore.instance?.settings?.pushByDefault ? this.messagesStore.instance?.settings?.pushByDefault : false,
                    startDate: new Date(),
                    endDate: button.component === "Event" ? this.dateTimeService.getDatePlusOneHour(new Date()) : undefined,
                    contacts: undefined,
                    iaTargetingOperator: undefined,
                    iaTargetingTargetContent: false,
                    categories: button.categories,
                    image: undefined,
                    approvers: approvers,
                    iaConfiguration: {
                      isNewsLink: button.messageType === "newsLinks"
                    }
                  };
                  this.setState({ loading: false });
                }
              }
              this.forceUpdate();
            }}
          />
        )
      });
    } else {
      elements.push(
        <div
          key={`NoContent`}
          className={styles.IA_noContent}
          style={{
            fontFamily: this.props.fontSlots?.body?.fontFamily
          }}
        >
          <IAIcon
            title="Info"
            size={25}
            color={"#999999"}
          />
          {this.localizationService.strings.ContentCreator_NoContent}
        </div>
      );
    }

    // My content
    let myContent = [];
    if (this.state.myContentItems != undefined && this.state.myContentItems.length > 0) {
      myContent = [];
      if (this.state.myContentItems) {
        this.state.myContentItems.forEach((myContentItem: IMyContentItem, index) => {
          myContent.push(
            <ContentCreatorItem
              key={`ContentCreatorItem_${index}`}
              contentItem={myContentItem}
              highlightColor={this.props.highlightColor}
              fontSlots={this.props.fontSlots}
              onClickDelete={(contentItemToDelete) => {
                this.setState({
                  contentItemToDelete,
                  showDeletePopup: true
                });
              }}
              onClickEdit={(contentItemToEdit) => {
                this.editItem(contentItemToEdit);
              }}
              onClickOpen={(contentItemToOpen) => {
                this.showItem(contentItemToOpen);
              }}
            />
          );
        });
      }
    } else {
      if (this.state.loadingMoreContent) {
        myContent = [];
        for (let i = 0; i < 4; i++) {
          myContent.push(
            <IASkeleton
              key={i}
              skeleton={{
                height: 84,
                width: "auto",
                borderRadius: 5,
                marginBottom: 20
              }}
            />
          );
        }
      } else {
        myContent.push(
          <div
            key={`NoContent`}
            className={styles.IA_noContent}
          >
            <IAIcon
              title="Info"
              size={25}
              color={"#999999"}
            />
            {this.localizationService.strings.Messages_ViewPanel_NoMessages}
          </div>
        );
      }
    }

    // Waiting for approval
    const isApprovalEnabledOnAnyInstance: boolean = this.props.componentInstances.Messages?.filter(i => i?.approvalEnabled)?.length > 0;
    const isCurrentUserApproverOnAnyInstance: boolean = this.props.componentInstances.Messages?.filter(i => i?.approvers?.filter(a => this.props.user && a.userPrincipalName.toLocaleLowerCase() === this.props.user?.userPrincipalName?.toLocaleLowerCase()).length > 0).length > 0;
    let waitingForApproval = [];
    if (this.state.waitingForApprovalItems != undefined && this.state.waitingForApprovalItems.length > 0) {
      waitingForApproval = [];
      if (this.state.waitingForApprovalItems) {
        this.state.waitingForApprovalItems.forEach((waitingForApprovalItem: IMyContentItem, index) => {
          waitingForApproval.push(
            <ContentCreatorItem
              key={`ContentCreatorItem_${index}`}
              contentItem={waitingForApprovalItem}
              fontSlots={this.props.fontSlots}
              highlightColor={this.props.highlightColor}
              isCurrentUserApprover={
                this.props.componentInstances.Messages && this.props.componentInstances.Messages?.filter(i => i.instanceName == waitingForApprovalItem.instanceName)[0]?.approvers?.
                  filter(i => this.props.user && i.userPrincipalName.toLocaleLowerCase() == this.props.user?.userPrincipalName.toLocaleLowerCase()).length > 0
              }
              onClickReview={(contentItemToReview) => {
                this.messagesStore.isReviewProcess = true;
                this.editItem(contentItemToReview);
              }}
              onClickEdit={(contentItemToEdit) => {
                this.messagesStore.isReviewProcess = true;
                this.editItem(contentItemToEdit);
              }}
              onClickOpen={(contentItemToOpen) => {
                this.showItem(contentItemToOpen);
              }}
            />
          );
        });
      }
    } else {
      if (this.state.loadingMoreContent) {
        waitingForApproval = [];
        for (let i = 0; i < 4; i++) {
          waitingForApproval.push(
            <IASkeleton
              key={i}
              skeleton={{
                height: 84,
                width: "auto",
                borderRadius: 5,
                marginBottom: 20
              }}
            />
          );
        }
      } else {
        waitingForApproval.push(
          <div
            key={`NoContent`}
            className={styles.IA_noContent}
            style={{
              fontFamily: this.props.fontSlots?.body?.fontFamily
            }}
          >
            <IAIcon
              title="Info"
              size={25}
              color={"#999999"}
            />
            {this.localizationService.strings.Messages_ViewPanel_NoMessages}
          </div>
        );
      }
    }

    // Push message panel
    let pushMessages = [];
    if (this.state.botMessagesItems && this.state.botMessagesItems.length > 0) {
      this.state.botMessagesItems.forEach((content: IMyContentItem, index) => {
        pushMessages.push(
          <IAPushMessageItem
            keyId={`PushMessageItem_${index}`}
            environment={this.props.environment}
            token={this.props.token}
            fontSlots={this.props.fontSlots}
            tenant={this.props.tenant}
            instance={content.instanceName}
            messageId={content.listItemId}
            title={content.title}
            date={content.date}
            highlightColor={this.messagesStore.highlightColor}
          />
        );
      });
    } else {
      if (this.state.loadingMoreContentPush) {
        pushMessages = [];
        for (let i = 0; i < 4; i++) {
          pushMessages.push(
            <IASkeleton
              key={i}
              skeleton={{
                height: 66,
                width: "auto",
                borderRadius: 5,
                marginBottom: 20
              }}
            />
          );
        }
      } else {
        pushMessages.push(
          <div
            key={`NoContent`}
            className={styles.IA_noContent}
          >
            <IAIcon
              title="Info"
              size={25}
              color={"#999999"}
            />
            {this.localizationService.strings.ContentCreator_PushPanel_NoContent}
          </div>
        );
      }
    }

    let tabs =
      [
        {
          key: "AddNew",
          text: this.localizationService.strings.ContentCreator_AddNew
        },
        {
          key: "MyContent",
          text: !!this.state.myContentTotalItems ? `${this.localizationService.strings.ContentCreator_MyContent} (${this.state.myContentTotalItems})` : this.localizationService.strings.ContentCreator_MyContent
        }
      ];
    if (isApprovalEnabledOnAnyInstance && isCurrentUserApproverOnAnyInstance) {
      tabs.push(
        {
          key: "WaitingForApproval",
          text: !!this.state.waitingForApprovalTotalItems ? `${this.localizationService.strings.ContentCreator_WaitingForApproval} (${this.state.waitingForApprovalTotalItems})` : this.localizationService.strings.ContentCreator_WaitingForApproval
        }
      );
    }
    // if (this.messagesStore.isBotInstalled) {
    //   tabs.push(
    //     {
    //       key: "PushMessages",
    //       text: this.localizationService.strings.ContentCreator_PushPanel_PushTitle
    //     }
    //   );
    // }

    let showLoadMoreButton = true;
    if ((this.state.selectedTab === "MyContent" && this.state.myContentItems.length >= this.state.myContentTotalItems)
      || (this.state.selectedTab === "WaitingForApproval" && this.state.waitingForApprovalItems.length >= this.state.waitingForApprovalTotalItems)
      || (this.state.selectedTab === "PushMessages" && this.state.botMessagesItems.length >= this.state.botMessagesTotalItems)) {
      showLoadMoreButton = false;
    }

    const content: JSX.Element = (
      <div className={styles.IA_contentCreator}>
        <div
          tabIndex={0}
          ref={this.focusRef}
          className={styles.IA_title}
          style={{
            fontFamily: this.props.fontSlots?.heading?.fontFamily
          }}
        >
          {this.localizationService.strings.ContentCreator_Headline}
        </div>
        {this.props.onClose != undefined &&
          <IAIcon
            title="Close"
            size={18}
            color="#777777"
            onClick={() => {
              this.props.onClose();
              this.setState({ show: false, showFilter: false });
            }}
            style={{
              cursor: "pointer",
              marginLeft: 10,
              position: "absolute",
              right: 20,
              top: 20
            }}
          />
        }
        <IAPivot
          highlightColor={this.props.highlightColor}
          items={tabs}
          selectedKey={this.state.selectedTab}
          select={(selectedTab: "AddNew" | "MyContent" | "WaitingForApproval" | "PushMessages") => {
            this.setState({ selectedTab });
            this.setState({
              myContentItems: [],
              waitingForApprovalItems: [],
              buttons: []
            }, () => {
              switch (selectedTab) {
                case "AddNew":
                  this.getButtons(this.props.environment, this.props.token, this.props.tenant, this.props.instance.instanceName);
                  break;
                case "MyContent":
                  this.getMyContent();
                  break;
                case "WaitingForApproval":
                  this.getWaitingForApproval();
                  break;
                case "PushMessages":
                  this.setState({ botMessagesItems: [], botMessagesTotalItems: 0 }, () => {
                    this.getBotMessages();
                  });
                default:
                  break;
              }
            });
          }}
        />
        {
          {
            "AddNew": elements,
            "MyContent":
              <div>
                <div className={styles.IA_filterArea}>
                  {this.messagesStore.filterData.isFiltered &&
                    <div className={styles.IA_filterBtn}>
                      <div
                        tabIndex={0}
                        onClick={() => this.clearFilters()}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            this.clearFilters();
                          }
                        }}
                        className="IA_OnFocusOutline_outer"
                        style={{ marginRight: 10 }}
                      >
                        <div
                          tabIndex={-1}
                          className="IA_OnFocusOutline_inner"
                        >
                          <IAIcon
                            title="ClearFilter"
                            size={18}
                            color={this.messagesStore.highlightColor}
                            style={{
                              marginTop: 0,
                              marginRight: 5
                            }}
                          />
                          {this.localizationService.strings.Messages_Clear_Filter}
                        </div>
                      </div>
                      <div className={styles.IA_filterSpace}> | </div>
                    </div>
                  }
                  {this.state.myContentInstances && this.state.myContentInstances.length > 0 &&
                    <div
                      ref={this.filterRef}
                      tabIndex={0}
                      className="IA_OnFocusOutline_outer"
                      onClick={() => {
                        this.showFilter();
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          this.showFilter();
                        }
                      }}
                    >

                      <div
                        tabIndex={-1}
                        className={[styles.IA_filterBtn, "IA_OnFocusOutline_inner"].join(" ")}
                      >

                        <IAIcon
                          title="Filter"
                          size={18}
                          color={this.messagesStore.highlightColor}
                          style={{
                            marginTop: 0,
                            marginRight: 5
                          }}
                        />
                        {this.localizationService.strings.Messages_Filter}</div>

                    </div>
                  }
                </div>

                <div style={{
                  color: "#b2b2b2",
                  marginBottom: 10,
                  fontSize: 12
                }}
                >
                  {this.localizationService.strings.ContentCreator_Modified}
                </div>
                {myContent}
                {this.state.loadingMoreContent && this.state.myContentItems?.length > 0 &&
                  <div key={"loader"} className={styles.loader}></div>
                }
              </div>,
            "WaitingForApproval":
              <div>
                <div style={{
                  color: "#b2b2b2",
                  marginBottom: 10,
                  fontSize: 12
                }}
                >
                  {this.localizationService.strings.ContentCreator_Modified}
                </div>
                {waitingForApproval}
                {this.state.loadingMoreContent && this.state.waitingForApprovalItems?.length > 0 &&
                  <div key={"loader"} className={styles.loader}></div>
                }
              </div>,
            "PushMessages":
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ marginTop: 0, fontFamily: this.props.fontSlots?.body?.fontFamily }}>{this.localizationService.strings.ContentCreator_PushPanel_PushSubTitle}</p>
                {pushMessages}
                {this.state.loadingMoreContentPush && this.state.botMessagesItems?.length > 0 &&
                  <div key={"loader"} className={styles.loader}></div>
                }
              </div>
          }[this.state.selectedTab]
        }
        {!this.state.loading && !this.state.loadingMoreContent && !this.state.loadingButtons && this.state.selectedTab !== "AddNew" && showLoadMoreButton &&
          <div className={styles.IA_loadMoreButtonContainer}>
            <IAButton
              label={this.localizationService.strings.ContentCreator_PushPanel_LoadMore}
              buttonColor={this.props.highlightColor}
              borderRadius={5}
              style={{
                marginBottom: 20,
              }}
              onClick={() => {
                if (this.state.selectedTab === "MyContent") {
                  this.getMyContent();
                }
                if (this.state.selectedTab === "WaitingForApproval") {
                  this.getWaitingForApproval();
                }
                if (this.state.selectedTab === "PushMessages") {
                  this.getBotMessages();
                }
              }}
            />
          </div>
        }
      </div>
    );
    let openInNewViewer = this.messagesStore.instance && this.messagesStore.messageToOpen && this.messagesStore.messageToOpen.iaConfiguration && this.messagesStore.messageToOpen.iaConfiguration.composerComponents;
    return (
      <div>
        <div id={`deletePopupId_${this.deletePopupId}`}>
          {this.state.showDeletePopup &&
            <IAPopup
              headline={this.localizationService.strings.Messages_DeletePopup_Headline}
              content={
                <div>
                  <div
                    style={{
                      float: "left"
                    }}
                  >
                    {this.localizationService.strings.Messages_DeletePopup_Message}
                  </div>
                  <div
                    style={{
                      clear: "both",
                      float: "left"
                    }}
                  >
                    <IAButton
                      label={this.localizationService.strings.Messages_DeletePopup_Yes}
                      buttonColor={this.props.highlightColor}
                      showSpinner={false}
                      onClick={async () => {
                        this.setState({
                          showDeletePopup: false,
                          myContentItems: [],
                          waitingForApprovalItems: [],
                          loadingMoreContent: true
                        });
                        switch (this.state.contentItemToDelete.site.toLocaleLowerCase()) {
                          case "intraactive-messages":
                            await MessageService.deleteMessage(this.state.contentItemToDelete.listItemId.toString(), this.props.environment != undefined ? this.props.environment : "Production", this.props.token, this.props.tenant, this.state.contentItemToDelete.instanceName);
                            break;
                          case "intraactive-events":
                            await EventService.deleteEvent(this.state.contentItemToDelete.listItemId.toString(), this.props.environment != undefined ? this.props.environment : "Production", this.props.token, this.props.tenant, this.state.contentItemToDelete.instanceName);
                            break;
                          case "intraactive-contentorganizer":
                            await ContentOrganizerService.deletePage(this.props.environment != undefined ? this.props.environment : "Production", this.props.token, this.props.tenant, this.state.contentItemToDelete.instanceName, this.state.contentItemToDelete.listItemId);
                            break;
                          default:
                            throw new Error("Not implemented");
                        }
                        this.setState({
                          contentItemToDelete: undefined,
                          contentItemToEdit: undefined,
                          contentItemToReview: undefined,
                          showDeletePopup: false,
                          loadingMoreContent: false,
                          myContentItems: [],
                          waitingForApprovalItems: [],
                        });
                        switch (this.state.selectedTab) {
                          case "MyContent":
                            this.getMyContent();
                            break;
                          case "WaitingForApproval":
                            this.getWaitingForApproval();
                            break;
                          default:
                            this.getMyContent();
                            break;
                        }
                      }}
                      style={{
                        marginTop: 20,
                        float: "left"
                      }}
                    />
                    <IAButton
                      label={this.localizationService.strings.Messages_DeletePopup_No}
                      buttonColor={"#999999"}
                      showSpinner={false}
                      onClick={() => {
                        this.setState({
                          contentItemToDelete: undefined,
                          showDeletePopup: false,
                        });
                      }}
                      style={{
                        marginTop: 20,
                        marginLeft: 10,
                        float: "left"
                      }}
                    />
                  </div>
                </div>
              }
              close={() => {
                this.setState({
                  contentItemToDelete: undefined,
                  showDeletePopup: false,
                });
              }}
            />
          }
        </div>
        <div id={`convertPopupId_${this.convertPopupId}`}>
          {this.state.showConvertToComposerPopup &&
            <IAPopup
              headline={this.localizationService.strings.Messages_ConvertToComposer_Headline}
              content={
                <div>
                  <div
                    style={{
                      float: "left"
                    }}
                  >
                    {this.messagesStore.component === "Event" ? this.localizationService.strings.Events_ConvertToComposer_Message : this.localizationService.strings.Messages_ConvertToComposer_Message}
                  </div>
                  <div
                    style={{
                      clear: "both",
                      float: "left"
                    }}
                  >
                    <IAButton
                      label={this.localizationService.strings.Messages_ConvertToComposer_ConvertButton}
                      buttonColor={this.props.highlightColor}
                      showSpinner={false}
                      onClick={() => {
                        this.setState({ contentItemToEdit: this.state.contentItemToOpen }, () => {
                          this.messagesStore.editMessage(this.messagesStore.messageToOpen ? this.messagesStore.messageToOpen : this.state.showConvertToComposerPopup);
                          this.setState({ showConvertToComposerPopup: undefined });
                        });
                      }}
                      style={{
                        marginTop: 20,
                        float: "left"
                      }}
                    />
                  </div>
                </div>
              }
              close={() => {
                this.setState({ showConvertToComposerPopup: undefined });
              }}
            />
          }
        </div>
        <div id={`cancelPopupId_${this.cancelPopupId}`}>
          {this.state.showCancelPopup &&
            <IAPopup
              headline={this.localizationService.strings.Messages_CancelPopup_Headline}
              content={
                <div>
                  <IAButton
                    label={this.localizationService.strings.Messages_CancelPopup_Yes}
                    buttonColor={this.props.highlightColor}
                    showSpinner={false}
                    onClick={() => {
                      this.setState({ show: true, showCancelPopup: false });
                      this.messagesStore.messageToEdit = undefined;
                      this.messagesStore.messageToEditOriginal = undefined;
                      this.messagesStore.creatingNewMessage = false;
                      document.body.style.overflowY = "auto";
                      document.body.style.height = "inherit";
                    }}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={this.localizationService.strings.Messages_CancelPopup_No}
                    buttonColor={"#999999"}
                    showSpinner={false}
                    onClick={() => {
                      this.setState({ showCancelPopup: false });
                    }}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              }
              close={() => {
                this.messagesStore.showCancelEditPopup = false;
              }}
            />
          }
        </div>

        <IAPanel
          approvers={this.messagesStore.messageToEdit ? this.messagesStore.messageToEdit.approvers : undefined}
          showOuterPanel={this.state.showFilter}
          isOuterPanel={false}
          open={this.state.show && (!this.messagesStore.messageToEdit && !this.messagesStore.messageToOpen && this.state.contentOrganizerInstanceToAddTo == undefined)}
          isFirstResponder={this.messagesStore && this.messagesStore.messageToOpen === undefined && this.messagesStore.messageToEdit === undefined}
          loading={this.state.loading}
          isMobile={this.props.isMobile}
          transition="slide"
          width={this.props.isMobile ? window.innerWidth : 600}
          highlightColor={this.props.highlightColor}
          marginTop={this.props.marginTop}
          user={this.messagesStore.user}
          tenant={this.props.tenant}
          token={this.props.token}
          environment={this.props.environment}
          close={() => {
            this.state.showFilter ? this.setState({ showFilter: false }) : this.setState({ show: false, showFilter: false });
            this.props.onClose();
          }}
          showNavigationBar={false}
          disableESCFunction={true}
          skeletonLoaderElements={Helper.getMessagesSkeletonElements()}
        >{content}
        </IAPanel>

        <Provider messagesStore={this.messagesStore}>
          <div>
            <OuterFilterPanel
              tenant={this.props.tenant}
              token={this.props.token}
              environment={this.props.environment}
              showOuterPanel={this.state.showFilter}
              instancesList={this.state.myContentInstances}
              reloadMessages={(resetPageCount) => this.getMyContent(resetPageCount)}
              clearFiltersKey={this.state.clearFiltersKey}
              close={() => {
                this.setState({ show: true, showFilter: false });
              }}
              disableESCFunction={true}
            />
          </div>
        </Provider>
        {this.state.show &&
          <Provider messagesStore={this.messagesStore}>
            <div>
              <EditPanel
                dataAutomationIdPrefix="messages-edit-panel"
                isContentCreator={true}
                reloadMessages={() => {
                  switch (this.state.selectedTab) {
                    case "MyContent":
                      this.setState({ myContentItems: [] });
                      this.getMyContent();
                      break;
                    case "WaitingForApproval":
                      this.setState({ waitingForApprovalItems: [] });
                      this.getWaitingForApproval();
                      break;
                    default:
                      this.setState({ myContentItems: [], waitingForApprovalItems: [] });
                      this.getMyContent();
                      break;
                  }
                }}
                onDelete={() => {
                  this.setState({ showDeletePopup: true, contentItemToDelete: this.state.contentItemToEdit });
                  if (this.messagesStore.messageToEdit == undefined) {
                    this.setState({ show: false });
                    this.render();
                  } else {
                    this.messagesStore.messageToEdit = undefined;
                    this.messagesStore.messageToEditOriginal = undefined;
                    this.messagesStore.creatingNewMessage = false;
                    document.body.style.overflowY = "auto";
                    document.body.style.height = "inherit";
                    this.render();
                  }
                }}
                onClose={() => {
                  if (this.messagesStore.messageToEdit == undefined) {
                    this.setState({ show: false });
                    this.render();
                  } else {
                    if (JSON.stringify(this.messagesStore.messageToEdit) !== JSON.stringify(this.messagesStore.messageToEditOriginal)) {
                      this.setState({ showCancelPopup: true });
                    } else {
                      this.messagesStore.messageToEdit = undefined;
                      this.messagesStore.messageToEditOriginal = undefined;
                      this.messagesStore.creatingNewMessage = false;
                      document.body.style.overflowY = "auto";
                      document.body.style.height = "inherit";
                      this.setState({ show: true }, this.render);
                    }
                  }
                }}
              />
              <OldViewPanel
                id={this.messagesStore.messageToOpen && this.messagesStore.messageToOpen.id && !openInNewViewer ? this.messagesStore.messageToOpen.id : undefined}
                dataAutomationIdPrefix="messages-view-panel"
                isContentCreator={true}
                enablePrint={true}
                onClose={() => {
                  this.messagesStore.clearTranslation();
                  this.messagesStore.closeMessage();
                  this.setState({ show: true }, this.render);
                }}
                onEdit={() => {
                  if (this.state.selectedTab === "WaitingForApproval") {
                    this.messagesStore.isReviewProcess = true;
                  }
                  this.setState({ showConvertToComposerPopup: this.state.contentItemToOpen });
                }}
              />
              <ViewPanel
                id={this.messagesStore.messageToOpen && this.messagesStore.messageToOpen.id && openInNewViewer ? this.messagesStore.messageToOpen.id : undefined}
                dataAutomationIdPrefix="messages-view-panel"
                isContentCreator={true}
                enablePrint={true}
                onClose={() => {
                  this.messagesStore.clearTranslation();
                  this.messagesStore.closeMessage();
                  this.setState({ show: true }, this.render);
                }}
                onEdit={() => {
                  if (this.state.selectedTab === "WaitingForApproval") {
                    this.messagesStore.isReviewProcess = true;
                  }
                  this.setState({ contentItemToEdit: this.state.contentItemToOpen }, () => {
                    this.messagesStore.editMessage(this.messagesStore.messageToOpen);
                    this.messagesStore.messageToEdit.iaTargetingTargetContent = false;
                    this.editItem(this.state.contentItemToOpen);
                  });
                }}
              />
              <ContentOrganizerPanel
                isMobile={this.props.isMobile}
                highlightColor={this.props.highlightColor}
                show={this.state.contentOrganizerInstanceToAddTo != undefined}
                instance={this.state.contentOrganizerInstanceToAddTo}
                environment={this.props.environment}
                token={this.props.token}
                tenant={this.props.tenant}
                onClose={() => {
                  this.setState({ contentOrganizerInstanceToAddTo: undefined });
                }}

              />
            </div>
          </Provider>
        }
      </div>
    );
  }
}
